import { twMerge } from 'tailwind-merge';

import { CircleSkeleton, InputSkeleton } from '@/_components';

export function LogoWithSelectorLoading({
  className,
  avatarContainerClassName,
  avatarClassName,
}: {
  className?: string;
  avatarContainerClassName?: string;
  avatarClassName?: string;
}) {
  return (
    <section
      className={twMerge(
        'col-span-12 flex flex-1 items-start justify-between select-none sm:col-span-6 sm:gap-y-2 md:col-span-12 lg:col-span-6 lg:flex-col lg:items-start 2xl:col-span-3',
        className
      )}
    >
      <div className={twMerge(`mb-px h-11 pr-2.5 pb-2`, avatarContainerClassName)}>
        <CircleSkeleton className={twMerge('size-11', avatarClassName)} />
      </div>

      <div className="mb-0 w-full sm:mb-0">
        <InputSkeleton noLabel />
      </div>
    </section>
  );
}
